import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import defaultModalStyle from "../../../common/modalStyles";

import Modal from "react-modal";

const ProlongedAction = memo(({ actionInProgress, title, message }) => {

	useEffect(() => {
		Modal.setAppElement(`body`);
	}, []);

	return (
		<Modal
			isOpen={actionInProgress}
			contentLabel="Action in progress"
			shouldCloseOnOverlayClick={false}
			style={defaultModalStyle.defaultModalStyle}
		>

			<div className="modalLayout">
				<div className="row">
					<h1 className="col-xs-12 titleForModal">
						<span className={`text-primary`}>{title}</span>
					</h1>
				</div>
				<div className="row form-group">
					<div className="col-xs-12">
						<span className={`text-primary`}>{message}</span>
					</div>
				</div>
			</div>
		</Modal>
	);
});
ProlongedAction.displayName = `DeleteInProgressModal`;

ProlongedAction.propTypes = {
	actionInProgress: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired
};

export default ProlongedAction;
